import { ActionTree } from 'vuex';
import { CartState } from './types';
import { RootState } from '../types';
import { compass } from '@resclick/compass';
import { PROPERTY_TYPES } from '@resclick/data-access';
import { date } from 'quasar';
import formatDate = date.formatDate;
import subtractFromDate = date.subtractFromDate;

export const actions: ActionTree<CartState, RootState> = {
  fetchCart({ commit, rootGetters }) {
    const cartId = window.localStorage.getItem('cartId');
    commit('setLoading', true);
    compass
      .do('carts', 'findOne', {
        query: {
          cartId,
          currency: rootGetters['preferences/currency'],
        },
      })
      .then((res) => {
        commit('setCart', res.data);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  addToCart({ commit, dispatch }, product) {
    commit('setLoading', true);
    if (PROPERTY_TYPES.includes(product.type)) {
      product.checkInDate = new Date(product.checkInDate);
      product.checkOutDate = new Date(product.checkOutDate);
      product.bookingDate = new Date(product.bookingDate);

      if (product.adults) {
        product.adults = Array.from({ length: product.adults }, () => ({
          gender: 'MALE',
          name: '',
          surname: '',
        }));
      }
      if (product.children) {
        product.children = product.children.map((age: number) => {
          return {
            gender: 'MALE',
            name: '',
            surname: '',
            dateOfBirth: formatDate(subtractFromDate(new Date(), { year: age }), 'YYYY-MM-DD'),
          };
        });
      }
    }

    const cartId = window.localStorage.getItem('cartId');
    compass
      .do('carts', 'addProduct', {
        query: { cartId },
        data: product,
      })
      .then(() => dispatch('fetchCart'));
  },

  removeFromCart({ commit, dispatch }, productId) {
    const cartId = window.localStorage.getItem('cartId');
    commit('setLoading', true);
    compass
      .do('carts', 'removeProduct', {
        params: { productId },
        query: { cartId },
      })
      .then(() => dispatch('fetchCart'));
  },
  clearCart({ commit, dispatch }) {
    commit('setLoading', true);
    const cartId = window.localStorage.getItem('cartId');
    compass
      .do('carts', 'clearCart', {
        query: { cartId },
      })
      .then(() => dispatch('fetchCart'));
  },
};
